import React from 'react';

import { TagOutlineIcon } from 'wanderu-components';
import type { I18nMoneyFunction } from 'wanderu-i18n';

import styles from './DiscountLineItem.scss';

interface DiscountLineItemProps {
    amount: number;
    code: string;
    currency: string;
    i18nMoney: I18nMoneyFunction;
    /** Display label shown above the code row. Pass a translated string. */
    label?: string;
    variant?: 'inline' | 'chip';
}

function DiscountLineItem({
    amount, code, currency, i18nMoney, label, variant = 'inline',
}: DiscountLineItemProps) {
    // Defense-in-depth: selectDiscountsByTrip only produces DiscountInfo when
    // discountTotal > 0, so amount should always be positive here. Guard kept
    // in case the component is used with a different data source.
    if (amount <= 0) return null;

    const formatted = i18nMoney.format(
        i18nMoney([{ [currency]: -amount }]).getTotalPrice(),
    );

    if (variant === 'chip') {
        return (
            <div className={styles.chipContainer} data-id="discount-line-item">
                {label && <span className={styles.label}>{label}</span>}
                <div className={styles.row}>
                    <span className={styles.codeChip}>
                        <TagOutlineIcon aria-hidden="true" className={styles.icon} />
                        {code}
                    </span>
                    <span className={styles.amount}>{formatted}</span>
                </div>
            </div>
        );
    }

    return (
        <div className={styles.row} data-id="discount-line-item">
            <div className={styles.codeGroup}>
                {label && <span className={styles.label}>{label}</span>}
                <span className={styles.codeInline}>
                    <TagOutlineIcon aria-hidden="true" className={styles.icon} />
                    {code}
                </span>
            </div>
            <span className={styles.amount}>{formatted}</span>
        </div>
    );
}

export type { DiscountLineItemProps };
export { DiscountLineItem };
